import axios from "axios";
import { FALLBACK_POVS, fallbackDialogue, FALLBACK_BIBLIOGRAPHY } from "@/lib/narrativeData";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function fetchPovs() {
  try {
    const { data } = await axios.get(`${API}/narrative/povs`);
    return data;
  } catch (e) {
    return FALLBACK_POVS;
  }
}

export async function fetchDialogue(pov, phase) {
  try {
    const { data } = await axios.get(`${API}/narrative/dialogue`, { params: { pov, phase } });
    return data;
  } catch (e) {
    return fallbackDialogue(pov, phase);
  }
}

export async function fetchBibliography() {
  try {
    const { data } = await axios.get(`${API}/narrative/bibliography`);
    return data;
  } catch (e) {
    return FALLBACK_BIBLIOGRAPHY;
  }
}

export async function postProgress(pov, completed_phase, remaining_seconds) {
  try {
    await axios.post(`${API}/narrative/progress`, { pov, completed_phase, remaining_seconds });
  } catch (e) {
    /* non-blocking */
  }
}
